module.exports = __webpack_public_path__ + "static/starter-signup-009905fd204c17afd5164bad91bfdd56.png";